import Component from './remark';
export default Component;
